import { Box, CircularProgress, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import I18n from "i18n-js";

export interface SimpleLoadingOverlayProps {
  open: boolean;
  transparent?: boolean;
}

export default function SimpleLoadingOverlay({
  open,
  transparent = false,
}: SimpleLoadingOverlayProps) {
  if (!open) return null;

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: transparent ? alpha("#fff", 0.8) : alpha("#fff", 0.9),
        zIndex: 1000,
        borderRadius: "inherit",
      }}
    >
      <Box sx={{ textAlign: "center" }}>
        <CircularProgress size={40} />
        <Typography>{I18n.t("App.loading")}</Typography>
      </Box>
    </Box>
  );
}
